import { render, staticRenderFns } from "./ChatInputComponent.vue?vue&type=template&id=10ab3b0f&scoped=true"
import script from "./ChatInputComponent.vue?vue&type=script&lang=js"
export * from "./ChatInputComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatInputComponent.vue?vue&type=style&index=0&id=10ab3b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab3b0f",
  null
  
)

export default component.exports